var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('van-loading',{attrs:{"type":"spinner","color":"#FF6046","vertical":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }